import api from './api';
import { ApiResponse } from '../types/common';
import { Draft, DraftDetailResponse } from '../types/draft';

export const draftService = {
  // 기안서 목록 조회 (검색 기능 포함)
  getDraftList: async (queryString?: string): Promise<ApiResponse<Draft[]>> => {
    const url = queryString ? `/api/draft/list${queryString}` : '/api/draft/list';
    const response = await api.get(url);
    return response.data;
  },

  // 기안서 등록 초기 데이터 조회
  getDraftInit: async (): Promise<ApiResponse<any>> => {
    const response = await api.get('/api/draft/init');
    return response.data;
  },

  // 기안서 상세 조회
  getDraftDetail: async (idx: number): Promise<ApiResponse<DraftDetailResponse>> => {
    const response = await api.get(`/api/draft/detail/${idx}`);
    return response.data;
  },

  // 기안서 등록
  createDraft: async (data: FormData): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/draft/create', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // 기안서 수정
  updateDraft: async (idx: number, data: FormData): Promise<ApiResponse<any>> => {
    const response = await api.post(`/api/draft/update/${idx}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // 기안서 삭제
  deleteDraft: async (idx: number): Promise<ApiResponse<any>> => {
    const response = await api.post(`/api/draft/delete/${idx}`);
    return response.data;
  },

  // 비용처리 완료
  paymentComplete: async (idx: number): Promise<ApiResponse<any>> => {
    const response = await api.post(`/api/draft/payment-complete/${idx}`);
    return response.data;
  },

  // 임시보관함 목록 조회
  getTmpList: async (): Promise<ApiResponse<any[]>> => {
    const response = await api.get('/api/draft/tmp/list');
    return response.data;
  },

  // 임시 기안서 상세 조회
  getTmpDetail: async (idx: number): Promise<ApiResponse<any>> => {
    const response = await api.get(`/api/draft/tmp/detail/${idx}`);
    return response.data;
  },

  // 임시저장
  saveTmp: async (data: any): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/draft/tmp/save', data);
    return response.data;
  },

  // 임시저장 업데이트
  updateTmp: async (idx: number, data: any): Promise<ApiResponse<any>> => {
    const response = await api.post(`/api/draft/tmp/update/${idx}`, data);
    return response.data;
  },

  // 임시저장 삭제
  deleteTmp: async (idx: number): Promise<ApiResponse<any>> => {
    const response = await api.post(`/api/draft/tmp/delete/${idx}`);
    return response.data;
  },

  // 기안서 승인
  confirmDraft: async (draftIds: number[]): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/draft/confirm', { draftIds });
    return response.data;
  },

  // 기안서 비용처리
  paymentDraft: async (draftIds: number[], confirmYN?: string): Promise<ApiResponse<any>> => {
    const response = await api.post('/api/draft/payment', { draftIds, confirmYN });
    return response.data;
  },
};
